export default __webpack_public_path__ + "static/media/logo.0bf1a688.svg";